import Theme from "@/components/Theme";
import Hero from "@/organisms/Hero";
import Trustpilot from "@/organisms/Trustpilot";
import AudioLayout from "@/organisms/AudioLayout";
import Slider from "@/components/organisms/Slider";
import ServicesSectionTwoCol from "@/components/organisms/ServicesSectionTwoCol";
import FeatureSectionTwocol from "@/organisms/FeatureSectionTwocol";
import RegistrationForm from "@/components/molecules/RegistrationForm";
import Faq from "@/components/organisms/FaqSection";
import Discover from "@/components/organisms/Discover";
import * as virtualReceptionist from "@/data/services/virtual-receptionist";

export async function getStaticPaths() {
  const paths = [{ params: { servicesPages: "virtual-receptionist" } }];

  return {
    paths: paths,
    fallback: false,
  };
}

export async function getStaticProps({ params: { servicesPages } }) {
  let data = {};
  const contentMap = {
    "virtual-receptionist": virtualReceptionist,
  };

  if (!servicesPages) {
    return {
      notFound: true,
    };
  }

  data.marketing = { ...contentMap[servicesPages]["marketing"] };
  data.content = { ...contentMap[servicesPages]["content"] };

  return {
    props: {
      data,
      pagename: servicesPages,
    },
  };
}

export default function ServicesPages({ data, pagename }) {
  const seoData = data?.marketing;
  const pagedata = data?.content;

  const hero = pagedata?.hasOwnProperty("hero") && (
    <Hero
      heroTitle={pagedata.hero.title}
      heroContent={pagedata.hero.content}
      heroImgData={pagedata.hero.heroImgData}
      hasPricingCta={pagedata.hero.hasPricingCta}
      hasTrustpilot={pagedata.hero.hasTrustpilot}
    />
  );

  return (
    <Theme mainClassName="main" hero={hero} seo={seoData}>
      {pagedata?.hasOwnProperty("featureSectionTwocol1") && (
        <FeatureSectionTwocol
          title={pagedata.featureSectionTwocol1.title}
          image={pagedata.featureSectionTwocol1.image}
          bgColor={pagedata.featureSectionTwocol1.bgColor}
          content={pagedata.featureSectionTwocol1.content}
          isImageOnLeft={pagedata.featureSectionTwocol1.isImageOnLeft}
          hasTitleDot={pagedata.featureSectionTwocol1.hasTitleDot}
        />
      )}
      {pagedata?.hasOwnProperty("servicesSectionTwoCol") && (
        <ServicesSectionTwoCol
          bgColor={pagedata.servicesSectionTwoCol.bgColor}
          label={pagedata.servicesSectionTwoCol.label}
          title={pagedata.servicesSectionTwoCol.title}
          subText={pagedata.servicesSectionTwoCol.subText}
          listData={pagedata.servicesSectionTwoCol.listData}
          image={pagedata.servicesSectionTwoCol.image}
          contentData={pagedata.servicesSectionTwoCol.contentData}
        />
      )}
      {pagedata?.hasOwnProperty("audioLayout") && (
        <AudioLayout
          title={pagedata.audioLayout.title}
          image={pagedata.audioLayout.image}
        />
      )}
      {pagedata?.hasOwnProperty("slider") && (
        <Slider
          data={pagedata.slider.data}
          variant={pagedata.slider.variant}
          title={pagedata.slider.title}
          subTitle={pagedata.slider.subTitle}
        />
      )}
      {pagedata?.hasOwnProperty("trustPilot") && (
        <Trustpilot
          title={pagedata.trustPilot.title}
          variant={pagedata.trustPilot.variant}
          className={pagedata.trustPilot.className}
        />
      )}
      {pagedata?.hasOwnProperty("miniRegister") && (
        <RegistrationForm
          title={pagedata.miniRegister.title}
          content={pagedata.miniRegister.content}
          hasBusinessNameField={false}
          variant="mini"
          formUniqueName={`page-${pagename}-mini`}
        ></RegistrationForm>
      )}
      {pagedata?.hasOwnProperty("faq") && <Faq data={pagedata.faq.faqData} />}
      {pagedata?.hasOwnProperty("discover") && (
        <Discover
          bgColor={pagedata.discover.bgColor}
          title={pagedata.discover.title}
          color={pagedata.discover.color}
          cta={pagedata.discover.cta}
          href={pagedata.discover.href}
        />
      )}
    </Theme>
  );
}
